$mol_view_tree2_to_js_test_ex_array_constructor_tuple_foo $mol_object
	blobs /
		<= text_blob? $mol_view_tree2_to_js_test_ex_klass_tuple<string> /
			/string
				<= text \123
			* type \text/plain
